import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole, isKnownRole } from '@/lib/sessionRole';
import { AppShell } from '@/components/layout/AppShell';

export const Route = createFileRoute('/parent')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: '/login' });
    const role = sessionRole(data.session);
    // A user with no recognized role is NOT silently treated as a parent:
    // send them to the explicit "no role assigned" state. Other known roles
    // bounce through the index, which routes them to their own dashboard.
    if (!isKnownRole(role)) throw redirect({ to: '/no-role' });
    if (role !== 'parent') throw redirect({ to: '/' });
  },
  component: ParentLayout,
});

function ParentLayout() {
  return (
    <AppShell
      role="parent"
      nav={[
        { to: '/parent', label: 'Today' },
        { to: '/parent/dancers', label: 'Dancers' },
        { to: '/parent/progress', label: 'Progress' },
        { to: '/parent/schedule', label: 'Schedule' },
        { to: '/parent/productions', label: 'Productions' },
        { to: '/parent/competitions', label: 'Competitions' },
        { to: '/parent/messages', label: 'Messages' },
        { to: '/parent/billing', label: 'Billing' },
        { to: '/parent/passes', label: 'Passes' },
        { to: '/parent/settings/notifications', label: 'Settings' },
      ]}
    >
      <Outlet />
    </AppShell>
  );
}
